export default {
  GET_SLEEP_PAGE_INFO: '/sleep_game/get_task_info',
  GET_SLEEP_REWARD: '/sleep_game/start_task',
  SETTLE_SLEEP_REWARD: '/sleep_game/settle_reward',
};
